import { QuotationConstants } from './quotation';

export enum ItemType {
    Translations,
    Subtitling,
    VoiceOver
};

export function toType(name: string) {
    switch (name) {
        case QuotationConstants.TRANSLATIONS:
            return ItemType.Translations;
        case QuotationConstants.SUBTITLES:
            return ItemType.Subtitling;
        case QuotationConstants.VOICEOVERS:
        default:
            return ItemType.VoiceOver;
    }
}

export function typeName(type: ItemType) {
    switch (type) {
        case ItemType.Subtitling:
            return 'Subtitling';
        case ItemType.Translations:
            return 'Translations';
        case ItemType.VoiceOver:
        default:
            return 'Voice overs';
    }
}